var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-group org-tab-content flex-3"},[_c('div',{staticClass:"col-n org-chart-dept flex-1"},[_c('PersonalFolderListContainer',{on:{"select":_vm.select}})],1),_c('div',{staticClass:"col-n org-chart-user flex-2"},[_c('PersonalMembersView',{attrs:{"dept":_vm.dept}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }